import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { settings } from '../../../settings';

@Injectable({
  providedIn: 'root',
})
export class OperatingAuthorityService {
  api = settings.API_URL;
  selectedOAdata: any = null;
  permitTypeCode: any = null;
  cityPermitData: any = null;
  accordCertData: any = null;
  vehicleData: any = null;
  passCount: any = null;

  constructor(private http: HttpClient) {}

  getOperatingAuthorityRecords(sessionHash: string, permitTypeCode: string) {
    const headers = new HttpHeaders({
      accept: 'text/plain',
    });
    return this.http.get(
      this.api +
        `/api/permits?sessionHash=${sessionHash}&permitTypeCode=${permitTypeCode}`,
      {
        headers,
      },
    );
  }

  getOperatingAuthorityVehicles(params: any) {
    return this.http.get(
      this.api + `/api/vehicles?sessionHash=${params.sessionHash}`,
    );
  }

  getOperatingAuthorityRecordsById(sessionHash: string, permitId: number) {
    return this.http.get(
      this.api + `/api/permits/${permitId}?sessionHash=${sessionHash}`,
    );
  }
  getOATypes(sessionHash: string) {
    return this.http.get(
      this.api + `/api/permitTypes?sessionHash=${sessionHash}`,
    );
  }
  getFeesAndInvoices(params: any) {
    return this.http.get(
      this.api +
        `/api/financialOperations/unpaidFeesInvoices?sessionHash=${params.sessionHash}&permitId=${params.permitId}`,
    );
  }

  getFees(params: any) {
    return this.http.get(
      this.api +
        `/api/financialOperations/fees?sessionHash=${params.sessionHash}&permitId=${params.permitId}`,
    );
  }

  getInvoices(params: any) {
    return this.http.get(
      this.api +
        `/api/financialOperations/invoices?sessionHash=${params.sessionHash}&permitId=${params.permitId}`,
    );
  }

  getPaymentHistory(params: any) {
    return this.http.get(
      this.api +
        `/api/financialOperations/payments?sessionHash=${params.sessionHash}&permitId=${params.permitId}`,
    );
  }

  addOperatingAuthoritiesService(params: any, sessionHash: string) {
    return this.http.post(
      this.api + `/api/permits?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  editOperatingAuthoritiesService(params: any, sessionHash: string) {
    return this.http.put(
      this.api + `/api/permits?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  getNotificationsService(sessionHash: string) {
    return this.http.get(
      this.api + `/api/notifications/all?sessionHash=${sessionHash}`,
    );
  }

  getNotificationMessage(params: any) {
    return this.http.get(
      this.api +
        `/api/notifications/message?sessionHash=${params.sessionHash}&notificationId=${params.notificationId}`,
    );
  }

  getTerminalsService(sessionHash: string) {
    return this.http.get(
      this.api +
        `/api/meetAndGreetRequests/terminals?sessionHash=${sessionHash}`,
    );
  }

  getEventsService(params: any) {
    return this.http.get(
      this.api +
        `/api/meetAndGreetRequests?sessionHash=${params?.sessionHash}&permitId=${params?.permitId}`,
    );
  }

  addEventService(params: any, sessionHash: string) {
    return this.http.post(
      this.api + `/api/meetAndGreetRequests?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  editEventService(params: any, sessionHash: string) {
    return this.http.put(
      this.api + `/api/meetAndGreetRequests?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  terminateEventService(params: any, sessionHash: string) {
    return this.http.put(
      this.api +
        `/api/meetAndGreetRequests/terminate?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  getReturningGuestsService(params: any) {
    return this.http.get(
      this.api +
        `/api/regularGuests?sessionHash=${params.sessionHash}&requestId=${params.requestId}`,
    );
  }

  addReturningGuestService(params: any, sessionHash: string) {
    return this.http.post(
      this.api + `/api/regularGuests?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  editReturningGuestService(params: any, sessionHash: string) {
    return this.http.put(
      this.api + `/api/regularGuests?sessionHash=${sessionHash}`,
      params.params,
      { responseType: 'text' },
    );
  }

  deleteReturningGuestService(params: any) {
    return this.http.delete(this.api + `/api/regularGuests`, {
      params: params,
      responseType: 'text',
    });
  }
}
